module.exports = __webpack_public_path__ + "173d98a42b0ac59bd4c53350dbb4482b.png";